// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2qrL2","errorLogs":"styles_errorLogs__WMcXC"};